import Cookies from './Cookies';
export default Cookies;



//////////////////
// WEBPACK FOOTER
// ./~/universal-cookie/es6/index.js
// module id = lGom
// module chunks = 4